<dialog #appHamburgerDialog class="hamburger-menu">
  <form method="dialog" class="hamburger-shade">
    <div class="hamburger-dialog-inner">
      <div class="hamburger-panel">
        @if (categoriesGroups()) {
          <div class="hamburger-menu-items">
            <div class="hamburger-panel-header">
              <div class="site-name">
                <p style="padding: 0 !important">Produktinformations-<br />system</p>
                <small class="w-full opacity-50">Version {{ version }}</small>
              </div>
            </div>
            <div class="pt-m">
              <a href="/news">
                <p class="flex gap-2 items-center" (click)="onNavigationClick('/news', $event)">
                  <app-icon alt="News" className="w-5 h-5" src="news-black.svg"></app-icon>News
                </p></a
              >
            </div>
            <!-- consultancy folder -->
            <div class="pt-m mb-4">
              <a href="/folders">
                <p class="flex gap-2 items-center" (click)="onNavigationClick('/folders', $event)">
                  <app-icon alt="Beratungsmappe" className="w-5 h-5" src="briefcase.svg"></app-icon>Beratungsmappe
                </p>
              </a>
            </div>
            <div>
              <p class="flex gap-2 items-center">
                <app-icon alt="Produkte" className="w-5 h-5" src="category.svg"></app-icon>Produkte
              </p>
              <div class="submenu-scroll-container">
                @for (item of categoriesGroups(); track item) {
                  @if (item.pages_1.length || item.pages_2.length) {
                    <div [ngClass]="{ active: categoryGroup() === item.id || categoryGroup() === item.slug }">
                      <a
                        [href]="'/pages/' + (item.slug ? item.slug : item.id)"
                        (click)="onNavigationClick('/pages/' + (item.slug ? item.slug : item.id), $event)">
                        <p class="sub-element">
                          {{ item.title }}
                        </p></a
                      >
                    </div>
                  }
                }
              </div>
            </div>

            <app-hamburger-bottom-nav
              (appsRequested)="openAppsStarter()"
              (profileRequested)="onNavigationClick('/users/profile', $event)"
              (logoutRequested)="logout()" />
          </div>
        }
      </div>
      <button (click)="onNavigationClick(null, $event)" class="hamburger-shade-close"></button>
    </div>
  </form>
</dialog>
@if ((authService.isAuthenticated() | async) === authState.Authenticated) {
  <app-apps-starter></app-apps-starter>
}
